import { ReactNode } from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

export function PermissoesPanelTitle({ title, extraContent }: { title: string; extraContent: ReactNode }) {
    return (
        <Box
            sx={{
                px: 2,
                py: 0.5,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: 'primary.main',
            }}
        >
            <Typography variant="subtitle1" sx={{ color: 'common.white', fontWeight: 400 }}>
                {title}
            </Typography>

            {extraContent}
        </Box>
    );
}
